var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"content-class":"dialogLoader","persistent":""},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('v-progress-circular',{staticClass:"loader",attrs:{"color":"primary","indeterminate":"","size":"100","width":"10"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }